import httpClient from "./httpClient";

export default {
  // Accommodations
  async getAccoms() {
    const response = await httpClient.get(`/accoms`);
    return response.data;
  },

  async deleteAccom(accomId) {
    const response = await httpClient.delete(`/accoms/${accomId}`);
    return response.data;
  },

  async createAccom(accom) {
    const response = await httpClient.post(`/accoms`, {
      ...accom
    });
    return response.data;
  },

  async updateAccom(accom) {
    const response = await httpClient.put(`/accoms/${accom.id}`, {
      ...accom
    });
    return response.data;
  },

  async getAccomReservations(accomId, params = {}) {
    const response = await httpClient.get(`/accoms/${accomId}/reservations`, {
      params
    });
    return response.data;
  }
};
